<template>
    <div class="vuse-content-wrapper">
        <vuse-section-definition
            :title="page"
            icon="dashboard"
            :breadcrumbs="breadcrumbs"
        ></vuse-section-definition>
        <v-container fluid class="home-content rounded-lg">
            <v-tabs v-model="tabIndex">
                <v-tab v-if="hasPermissions('List role')">Danh sách vai trò</v-tab>
                <v-tab v-if="hasPermissions('List user')">Danh sách người dùng</v-tab>
            </v-tabs>
            <!-- <v-tabs v-model="tabIndex">
                <v-tab v-for="item in items" :key="item.id">{{ item.tab }}</v-tab>
            </v-tabs> -->

             
            <v-tabs-items v-model="tabIndex" class="min-width">
            <v-tab-item active class="" v-if="hasPermissions('List role')">
                <list-role></list-role>
            </v-tab-item>
            <v-tab-item v-if="hasPermissions('List user')">
                <list-user></list-user>
            </v-tab-item>
            </v-tabs-items>
        </v-container>
    </div>
</template>
<script>
  import ListRole from "@/components/role_user/list_role";
  import ListUser from "@/components/role_user/list_user";
  export default {
    components: {
      ListRole,
      ListUser
    },
    data() {
        return {
        tabIndex: 0,
        items: [
            {id: 0, tab: "Danh sách vai trò"},
            // { id: 1, tab: "Countdown" },
            {id: 1, tab: "Danh sách người dùng"},
        ],
        page: "Quản trị vai trò người dùng",
        breadcrumbs: [
            {
            text: "Trang chủ",
            disabled: true,
            },
            {
                text: "Quản trị vai trò người dùng",
            disabled: true,
            }
        ],
        };
    },
  }
</script>
